import { __assign } from "tslib";
export var LARGE_CONTAINER_SIZE = 1920;
export var defaultLayoutConfig = {
    rowSizeDesktop: 270,
    rowSizeMobile: 250,
    rowSizeMobileLarge: 250,
    rowSizeCardDesktop: 360,
    rowSizeCardMobile: 250,
    itemSpacingDesktop: 8,
    itemSpacingMobile: 8,
    itemSpacingCardDesktop: 16,
    itemSpacingCardMobile: 8,
    galleryGutter: false,
};
export var defaultLayoutConfig_desktop_torpedo_310 = __assign(__assign({}, defaultLayoutConfig), { rowSizeDesktop: 290, itemSpacingDesktop: 2 });
//# sourceMappingURL=constants.js.map